import { createIcon } from '@chakra-ui/icons';

export const Settings = createIcon({
  displayName: 'Settings',
  viewBox: '0 0 12 12',
  path: [
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 2H11.5" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="square" />
      <path d="M0.5 2H2" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="square" />
      <path
        d="M4 0.5H2V3.5H4V0.5Z"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path d="M11 6H11.5" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="square" />
      <path d="M0.5 6H7" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="square" />
      <path
        d="M9 4.5H7V7.5H9V4.5Z"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path d="M6 10H11.5" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="square" />
      <path d="M0.5 10H2" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="square" />
      <path
        d="M4 8.5H2V11.5H4V8.5Z"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>,
  ],
});
